<template>
    <main class="tip-contanier">
        <section class="img-contanier">
            <el-image style="width: 100%; height: 100%" :src="url" :fit="fit" :lazy="true"></el-image>
        </section>
        <section class="content-contanier">
            <p class="content-title">{{title}}</p>
            <p class="content-main">{{content}}</p>
        </section>
    </main>
</template>

<script>
export default {
    props:{
        url:{
            type:String,
            default:''
        },
        title:{
            type:String,
            default:''
        },
        content:{
            type:String,
            default:''
        }
    },
    data(){
        return {
            fit:"cover"
        }
    }
}
</script>
<style lang="less" scoped>
    .tip-contanier{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        .img-contanier{
            max-width: 50px;
            @media all and (max-width: 480px) {
                max-width: 35px;
            }
        }
        .content-contanier{
            flex: 1;
            & .content-title{
                text-align: center;
                font-size: 20px;
                margin: 10px 0;
                @media all and (max-width: 800px) {
                    font-size: 16px;
                }
            }
            & .content-main{
                text-align: center;
                font-size: 18px;
                color:#919599;
                padding: 0 10px;
                @media all and (max-width: 800px) {
                    font-size: 14px;
                }
            }
        }
    }
</style>
